import React from 'react';
import { hint, input, label as labelStyle } from '../../../shared/ui/formStyles';

// Пара полей UA/EN. Везде одинаковая, чтобы редактор не выглядел
// собранным из разных кусков.
const LocalizedField = ({ title, description, value, onChange, rows, placeholder }) => (
  <div style={{ marginBottom: '16px' }}>
    {title && <span style={labelStyle}>{title}</span>}
    {description && <p style={{ ...hint, margin: '0 0 8px' }}>{description}</p>}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      {['ua', 'en'].map((locale) => (
        <div key={locale}>
          <span style={{ fontSize: '11px', color: '#94A3B8' }}>
            {locale === 'ua' ? 'Українською' : 'Англійською'}
          </span>
          {rows ? (
            <textarea
              rows={rows}
              value={value?.[locale] || ''}
              placeholder={placeholder}
              onChange={(e) => onChange({ ...value, [locale]: e.target.value })}
              style={{ ...input, marginTop: '3px' }}
            />
          ) : (
            <input
              type="text"
              value={value?.[locale] || ''}
              placeholder={placeholder}
              onChange={(e) => onChange({ ...value, [locale]: e.target.value })}
              style={{ ...input, marginTop: '3px' }}
            />
          )}
        </div>
      ))}
    </div>
  </div>
);

export default LocalizedField;
